import {
  Button,
  ButtonTypeMap,
  ExtendButtonBase,
  Popover,
  Typography,
} from "@mui/material"
import { useEffect, useState } from "react"
import { useCopyToClipboard } from "../hooks"

interface IPropsWithChildren {
  children: string
}
interface IPropsWithParameter {
  text: string
}
type IProps = {
  buttonProps?: Omit<ExtendButtonBase<ButtonTypeMap>, "onClick">
} & (IPropsWithChildren | IPropsWithParameter)

export const InlineCode = ({ buttonProps, ...props }: IProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const { copied, copy } = useCopyToClipboard()
  const text = "text" in props ? props.text : props.children

  // Close the "Скопировано" popover when the feedback window ends.
  useEffect(() => {
    if (!copied && anchorEl !== null) {
      setAnchorEl(null)
    }
  }, [copied, anchorEl])

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    copy(text)
    setAnchorEl(event.currentTarget)
  }

  const open = !!anchorEl
  const id = open ? "simple-popover" : undefined

  return (
    <>
      <Button
        onClick={handleClick}
        sx={(theme) => ({
          textTransform: "none",
          py: 0,
          px: "4px",
          backgroundColor: `${theme.palette.background.paper}`,
        })}
        color="secondary"
        {...buttonProps}
      >
        <Typography variant="caption" fontFamily="monospace" component="span">
          {text}
        </Typography>
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Typography sx={{ p: 1 }} component="div">
          Скопировано
        </Typography>
      </Popover>
    </>
  )
}
